import { simReducer } from './simulationReducer';

const simulationReducer = simReducer('TEMP_');

export const initialState = {
  fetched: false,
  simulation: null,
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case 'TEMP_SIMULATION_STARTED':
    case 'TEMP_SIMULATION_FINISHED':
      return Object.assign({}, state, { simulation: simulationReducer(state.simulation, action) });
    default:
      return state;
  }
}
